import { toPersianDigits } from './toPersianDigits';

// تبدیل تاریخ با فرمت RFC 1123 (مثل "Wed, 13 May 2026 00:49:39 GMT")
const parseDate = (dateStr) => {
  if (!dateStr) return new Date(NaN);
  
  try {
    // برای فرمت RFC 1123، new Date مستقیماً آن را می‌فهمد
    const date = new Date(dateStr);
    
    // چک کردن اعتبار
    if (!isNaN(date.getTime())) {
      return date;
    }
    
    return new Date(NaN);
  } catch (e) {
    return new Date(NaN);
  }
};

export function formatRelativeTime(dateStr) {
  if (!dateStr) return '';
  
  try {
    const now = new Date();
    const date = parseDate(dateStr);
    
    // بررسی اعتبار تاریخ
    if (isNaN(date.getTime())) {
      console.warn('Invalid date:', dateStr);
      return '';
    }
    
    const diffMs = now - date;
    const diffMin = Math.floor(diffMs / 60000);
    
    // Future-dated news must not appear in any feed.
    // This is only a defensive fallback for direct/shared items.
    if (diffMin < 0) {
      return '';
    }
    
    // تاریخ در گذشته است
    if (diffMin < 1) return 'لحظاتی پیش';
    if (diffMin < 60) return `${toPersianDigits(diffMin)} دقیقه پیش`;
    
    const diffHr = Math.floor(diffMin / 60);
    if (diffHr < 24) return `${toPersianDigits(diffHr)} ساعت پیش`;
    
    const diffDay = Math.floor(diffHr / 24);
    if (diffDay === 1) return 'دیروز';
    return `${toPersianDigits(diffDay)} روز پیش`;
  } catch (e) {
    console.error('Error in formatRelativeTime:', e);
    return '';
  }
}